define('TescoMobile_Checkout/js/view/cart-item-renderer',['ko', 'Magento_Checkout/js/view/cart-item-renderer', 'Magento_Customer/js/customer-data', 'Magento_Catalog/js/price-utils'], function (ko, Component, customerData, priceUtils) {
  'use strict';

  return Component.extend({
    collapsibleState: ko.observable(true),
    defaults: {
      extensionTemplates: {
        device: [],
        tariff: [],
        monthly: [],
        today: [],
        upfront: [],
        esim: []
      }
    },
    initialize: function () {
      this._super();
      this.setDetailsState();
    },
    getFormattedPrice: function (price) {
      return priceUtils.formatPrice(price);
    },
    setDetailsState: function () {
      const cart = customerData.get('cart');
      parseInt(cart().summary_count) > 1 ? this.collapsibleState(false) : this.collapsibleState(true);
    }
  });
});

